import React from "react";
import PropTypes from "prop-types";

import styles from "./Description.module.css";

const Description = ({
  heading,
  description,
  descriptionArticle,
  rightToLeft,
}) => {
  const rightToLeftStyles = rightToLeft ? styles.rightToLeft : "";

  return (
    <article className={`${styles.contentWrapper} ${rightToLeftStyles}`}>
      <div className={`${styles.content}`}>
        <h3 className={styles.heading}>{heading}</h3>
        {description && <p className={styles.description}>{description}</p>}
        {descriptionArticle && (
          <div className={styles.descriptionArticle}>{descriptionArticle}</div>
        )}
      </div>
    </article>
  );
};

Description.propTypes = {
  /** Description heading */
  heading: PropTypes.string.isRequired,

  /** Description paragraph */
  description: PropTypes.string,

  /** Verbose description */
  descriptionArticle: PropTypes.node,

  /** Whether the layout is right to left */
  rightToLeft: PropTypes.bool,
};

Description.defaultProps = {
  rightToLeft: false,
};

export default Description;
